export const CheckCircle = (props) => {
  const { size = 24, onClick, verticalAlign, marginLeft, marginRight, top, color, className } = props;
  return (
    <span onClick={onClick} className={`icon-wrap ${className ? className : ''}`} style={{ marginLeft, marginRight, top, color }}>
      <svg xmlns='http://www.w3.org/2000/svg' style={{ verticalAlign }} width={size} height={size} fill='none' viewBox='0 0 24 24'>
        <path
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='1.5'
          d='M7.5 12l3 3 6-6m5.5 3c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10z'
        ></path>
      </svg>
    </span>
  );
};
